/**
 * Base Spacing Tokens
 * 8px grid system and common patterns
 */

export const baseSpacing = {
  // Base unit (8px)
  unit: 8,

  // Scale (multipliers of the base unit)
  // 0 = 0px, 1 = 8px, 2 = 16px, 3 = 24px, etc.
  scale: {
    0: 0,
    1: 1,   // 8px
    2: 2,   // 16px
    3: 3,   // 24px
    4: 4,   // 32px
    5: 5,   // 40px
    6: 6,   // 48px
    7: 7,   // 56px
    8: 8,   // 64px
    9: 9,   // 72px
    10: 10, // 80px
    11: 11, // 88px
    12: 12, // 96px
  },

  // Common patterns (for consistent usage)
  patterns: {
    // Card spacing
    cardMargin: [0, 2, 2, 2], // [top, right, bottom, left] in scale units
    cardPadding: 2,           // 16px
    cardPaddingCompact: 1,    // 8px
    cardPaddingLarge: 3,      // 24px

    // Container spacing
    containerPadding: 3,      // 24px

    // Icon sizes (in pixels, not grid units)
    iconSize: {
      small: 20,
      medium: 32,
      large: 40,
    },

    // Common gaps
    gap: {
      xs: 0.5,   // 4px
      sm: 1,     // 8px
      md: 2,     // 16px
      lg: 3,     // 24px
      xl: 4,     // 32px
    },

    // Section spacing
    sectionSpacing: {
      small: 2,   // 16px
      medium: 4,  // 32px
      large: 6,   // 48px
    },
  },
} as const;

export type BaseSpacing = typeof baseSpacing;
